module.exports = __webpack_public_path__ + "531d1a89dc4322e9ef4798a01243cdbe.webm";